/***
 * We define all the boot functions for each landing page here
 * Note that boot functions are guaranteed to run after DOM has loaded
 */
export const bootFunctions = {
    indexAppDirectory: function () {
        var free_app_order = [
            "crimson",
            "magento",
            "podio",
            "resonance",
            "openq",
            "tradablebits",
            "ubervu",
            "uberflip",
            "marketo",
            "weiboanalytics",
            "kapost",
            "circulateit",
            "crowdriff",
            "reviewinc",
            "simplebooklet",
            "soundcloudfree",
            "talkwalker",
            "justunfollow",
            "demographicspro",
            "sinaweibo",
            "reputology",
            "socialflow",
            "ofunnel",
            "foursquare",
            "vidiq",
            "likehack",
            "appnet",
            "chartbeat",
            "nimble",
            "cashie",
            "gaggleamp",
            "brandwatch",
            "dailymotion",
            "brightkit",
            "zendesk",
            "mailchimp-new",
            "hootSuiteSyndicator",
            "vidcaster",
            "shopseen",
            "vidyard",
            "twtrland",
            "simplesalestracking",
            "surveyMonkey",
            "contentGems",
            "trendspottr_free",
            "123formbuilder",
            "crowdcontent",
            "vk",
            "tencentweibo",
            "zyncro",
            "rankspeed",
            "blogger",
            "batchbook",
            "appboy",
            "storeya",
            "socialcast",
            "instagram",
            "youtube_free",
            "tumblr",
            "evernote",
            "mailchimp",
            "flickr",
            "getsatisfaction",
            "yammer",
            "rss",
            "wordpress",
            "vimeo",
            "reddit",
            "stumbleupon",
            "scoop.it",
            "stocktwits",
            "constantcontact",
            "socialbro",
            "storify",
            "via.me",
            "nexalogy",
            "weibo",
            "renren",
            "xing",
            "viadeo",
            "cmp.ly",
            "needtagger",
            "zuum",
            "videolicious"
        ];


        $.each(free_app_order, function (index, value) {
            // appending a div to .sorted_free_apps actually removes it from .unsorted_apps
            $(".sorted_free_apps").append($(".unsorted_apps").find('div.grid_row.feature[appname="' + value + '"]'));
        });

        var paid_app_order = [
            "fbpage",
            "onedrive",
            "catchappbox",
            "catchappdropbox",
            "box",
            "trello",
            "dropbox",
            "googledrive",
            "vkcommunities",
            "googledrivefeeds",
            "soundcloud",
            "gmail",
            "viraltag",
            "hootbulk",
            "sugarcrm",
            "youtubeanalytics",
            "youtube_paid",
            "statigram",
            "trendspottr",
            "salesforce",
            "leadsift",
            "chattback"
        ];

        $.each(paid_app_order, function (index, value) {
            // appending a div to .sorted_paid_apps actually removes it from .unsorted_apps
            $(".sorted_paid_apps").append($(".unsorted_apps").find('div.grid_row.feature[appname="' + value + '"]'));
        });

        //Gabriel said i could
        var filterResults = function (filterText) {
            var $apps = $('._filterApps .feature');
            filterText = $.trim(filterText);
            if (!filterText) {
                $apps.show();
                return;
            }
            $apps.hide().filter(":Contains('" + filterText + "')").show();
        };

        $('._searchAppDesc').keyup(function () {
            filterResults($('._searchAppDesc').val());
        });
    }
};
